import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ["translationsList", "searchInput", "form", "translationResult"]

  connect() {
    // Listen for chat document selection
    this.boundHandleDocumentSelect = this.handleDocumentSelect.bind(this)
    this.element.addEventListener('chat:documentSelected', this.boundHandleDocumentSelect)
    
    // Add form submit handler
    this.formTarget.addEventListener('submit', this.submitForm.bind(this))

    // Clear translation when translations-list frame updates
    document.addEventListener("turbo:frame-load", this.handleFrameLoad.bind(this))

    // Subscribe to translation progress updates
    this.subscription = consumer.subscriptions.create("TranslationProgressChannel", {
      received: this.handleProgressUpdate.bind(this)
    })
  }

  disconnect() {
    // Clean up listeners
    this.element.removeEventListener('chat:documentSelected', this.boundHandleDocumentSelect)
    this.formTarget.removeEventListener('submit', this.submitForm.bind(this))
    document.removeEventListener("turbo:frame-load", this.handleFrameLoad.bind(this))

    // Unsubscribe from Action Cable
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleFrameLoad(event) {
    if (event.target.id === "translations-list") {
      const originalText = document.getElementById('originalText')
      const translatedText = document.getElementById('translatedText')
      const resultContainer = document.getElementById('translationResult')
      if (originalText) originalText.innerHTML = ''
      if (translatedText) translatedText.innerHTML = ''
      if (resultContainer) resultContainer.classList.add('d-none')
    }
  }

  handleDocumentSelect(event) {
    // Don't reset if this was triggered by view-translation button
    if (event.detail && event.detail.source === 'view-translation') {
      return
    }
    
    // Reset to base URL without query parameters
    window.location.href = window.location.pathname
  }

  async submitForm(event) {
    event.preventDefault()
    console.log('Form submission intercepted')
    
    const form = event.target
    const formData = new FormData(form)
    const submitButton = form.querySelector('button[type="submit"]')
    
    try {
      submitButton.disabled = true
      this.translationResultTarget.classList.add('d-none')
      
      console.log('Sending fetch request to /pdf_translator/translate')
      const response = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      Turbo.renderStreamMessage(html)

      // Reset form and file preview on success
      form.reset()
      const previewElement = form.querySelector('[data-dropzone-target="preview"]')
      if (previewElement) {
        previewElement.innerHTML = ''
      }

    } catch (error) {
      console.error('Translation error:', error)
      alert('Error starting translation: ' + error.message)
    } finally {
      submitButton.disabled = false
    }
  }

  handleProgressUpdate(data) {
    if (data.translation_id) {
      const progressContainer = document.querySelector(`[data-translation-id="${data.translation_id}"]`)
      const progressBar = progressContainer?.querySelector('.progress-bar')
      
      if (progressContainer && progressBar) {
        if (data.error) {
          progressBar.classList.remove('bg-success')
          progressBar.classList.add('bg-danger')
          progressBar.style.width = '100%'
          progressBar.textContent = data.error
          return
        }

        progressBar.style.width = `${data.progress}%`
        progressBar.setAttribute('aria-valuenow', data.progress)
        progressBar.textContent = `${data.progress}%`
        
        if (data.complete) {
          // Remove the progress bar when complete
          progressContainer.remove()
          // Refresh the page to show updated translation
          window.location.reload()
        }
      }
    }
  }
}
